import {ENV} from "../../env.js"
window.ENV = ENV;



